<style src="./ParkBlock.scss" lang="scss"></style>
<template>
  <div class="park-block">
    <div class="header">
      <span class="parkname">{{ park.parkName }}</span>

      <div class="containermenu">
        <button type="button" class="buttonmenu">
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <ul class="monitors">
      <li
        class="monitorname"
        v-for="(monitor, monitorIdx) in park.monitors"
        :key="monitorIdx"
        @click="openChat(monitor.userToken)"
      >
        {{ monitor.fullName }}
      </li>
    </ul>

    <div class="spots">
      <div
        v-for="(prk, prkIdx) in park.spots"
        :key="prkIdx"
        class="spot"
        :class="{
          spot__free: prk.isFree,
          spot__regular: prk.isRegular,
          spot__irregular: prk.isIrregular,
          spot__special: prk.isSpecial,
          spot__checkout: prk.isCheckout,
          spot__tariff: prk.tariffSchedule,
        }"
        :title="prk.vehicle ? prk.vehicle.licencePlate : ''"
      >
        <small>{{ prk.name }} </small>
      </div>
    </div>

    <footer class="stats">
      <span class="count total">{{ park.stats.countTotal }}</span>
      <span class="count free">{{ park.stats.countFree }}</span>
      <span class="count regular">{{ park.stats.countRegular }}</span>
      <span class="count irregular">{{ park.stats.countIrregular }}</span>
      <span class="count special">{{ park.stats.countSpecial }}</span>
      <span class="count checkout">{{ park.stats.countCheckout }}</span>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ParkBlock',
  props: {
    park: {
      default: null,
    },
  },

  methods: {
    openChat(userToken) {
      this.$router.push({
        name: 'MonitorMessageAttendance',
        params: { userToken },
      });
    },
  },
};
</script>
